import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MoneyPipe } from '../../pipes/framework/money-short.pipe';
import { TooltipDirective } from '@app/directives/tooltip.directive';

@Component({
  selector: 'app-formatted-money',
  templateUrl: './formatted-money.component.html',
  styleUrls: ['./formatted-money.component.scss'],
  imports: [NgClass, MoneyPipe, TooltipDirective],
})
export class FormattedMoneyComponent {
  @Input() value: number;
}
